import { HNUSBusinessAccountHolder } from 'API';
import { highnoteService } from 'app/services/highnote.service';

export async function getHNBusinessAccountHolder(id: string): Promise<HNUSBusinessAccountHolder | undefined> {
  if (!id || id.trim() === '') {
    console.error('[ONBOARD][getHNBusinessAccountHolder] Invalid or empty ID provided:', { id });
    return undefined;
  }

  const result = await highnoteService.hnGetBusinessAccountHolder({ id });
  return result as HNUSBusinessAccountHolder;
}
